/**
 * @param {function} callback
 */
export default function firstUserAction (callback) {
  let touch = false
  // !!! DEBUG !!!
  console.log(`%c onFirstAction() %c callback: `, 'background:#ffbb00;color:#000', 'color:#00aaff', callback)
  document.addEventListener('touchstart', onFirstTouch)
  document.addEventListener('click', onFirstClick)

  function onFirstTouch (e) {
    touch = true
    document.removeEventListener('touchstart', onFirstTouch)
    callback(e)
  }

  function onFirstClick (e) {
    document.removeEventListener('click', onFirstClick)
    if (!touch) {
      document.removeEventListener('touchstart', onFirstTouch)
      callback(e)
    }
  }
}
